/* eslint-disable react/prop-types */
import { Upload as UploadAD, Modal, Spin } from 'antd';
import { useState } from 'react';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { fileToBase64 } from 'utils/fileToBase64';
import './Upload.scss';
import { imgDefaultVideo } from 'containers/Monitoreos/MediosImpresos/components/modalVideo';

const Upload = (props) => {
  const { value, className, loading, hideNextUpload, aceptaVideo, ...restProps } = props;
  const files = value?.fileList?.map((file) => {
    if (file.type !== undefined && file.type !== null) {
      if (file.type === 'video/mp4') {
        return {
          ...file,
          thumbUrl: imgDefaultVideo
        };
      }
    }
    if (file.thumbUrl !== undefined && file.thumbUrl !== null) {
      if (file.thumbUrl.startsWith('data:video/')) {
        return {
          ...file,
          thumbUrl: imgDefaultVideo
        };
      }
    }

    return file;
  });

  const getFullBase64 = async (file) => {
    const dataImageUri = await fileToBase64(file);
    // Agregamos la imagen completa en base64
    // eslint-disable-next-line no-param-reassign
    file.fullBase64Img = dataImageUri;
    const newFile = file;
    if (file.type === 'video/mp4') {
      newFile.thumbUrl = imgDefaultVideo;
    }
  };

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewVideo, setPreviewVideo] = useState('');
  const [videoKey, setVideoKey] = useState(0);

  const handleBeforeUpload = (file) => {
    getFullBase64(file);
    // Regresamos false para que el componente upload nos delegue la carga del archivo
    return false;
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      if (file.type === 'video/mp4') {
        const updatedFile = { ...file };
        updatedFile.url = await fileToBase64(file.originFileObj);
        setPreviewVideo(updatedFile.url);
        setVideoKey((prevKey) => prevKey + 1);
        setPreviewImage('');
      } else {
        // eslint-disable-next-line no-param-reassign
        file.preview = await fileToBase64(file.originFileObj);
        setPreviewVideo('');
        setPreviewImage(file.url || file.preview);
      }
      setPreviewOpen(true);
    } else {
      if (file.url?.startsWith('data:video/')) {
        // console.log('urlFile', file.url.substring(0, 20));
        setPreviewVideo(file.url);
        setPreviewImage('');
        setVideoKey((prevKey) => prevKey + 1);
      } else {
        setPreviewVideo('');
        setPreviewImage(file.url || file.preview);
      }
      setPreviewOpen(true);
    }
  };

  const handleCancel = () => setPreviewOpen(false);

  const UploadButton = (
    <div>
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 24
              }}
              spin
            />
          }
        />
      ) : (
        <>
          <PlusOutlined style={{ fontSize: 20 }} />
          <div
            style={{
              marginTop: 8
            }}>
            Subir
          </div>
        </>
      )}
    </div>
  );
  // console.log(hideNextUpload);

  return (
    <>
      <UploadAD
        accept={aceptaVideo === true ? 'image/png, image/jpeg, video/mp4' : 'image/png, image/jpeg'}
        className={`upload ${className}`}
        fileList={files}
        listType="picture-card"
        beforeUpload={handleBeforeUpload}
        onPreview={handlePreview}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...restProps}>
        {!hideNextUpload && (files?.length > 0 ? null : UploadButton)}
      </UploadAD>
      <Modal open={previewOpen} footer={null} onCancel={handleCancel} title="Vista previa">
        {previewImage && (
          <img
            alt="imagen"
            style={{
              width: '100%'
            }}
            src={previewImage}
          />
        )}
        {previewVideo && (
          <video
            key={videoKey}
            controls
            style={{
              width: '100%'
            }}>
            <source src={previewVideo} type="video/mp4" />
            <track kind="captions" srcLang="es" label="Subtitles" />
            Tu navegador no soporta el elemento de video.
          </video>
        )}
      </Modal>
    </>
  );
};

Upload.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.string,
  value: PropTypes.shape({ fileList: PropTypes.arrayOf(PropTypes.shape({})) }),
  loading: PropTypes.bool,
  aceptaVideo: PropTypes.bool
};

Upload.defaultProps = {
  className: '',
  value: undefined,
  loading: false,
  aceptaVideo: true
};

export default Upload;
